'use client';
import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import AnchorButton from '../common/AnchorButton.mjs';
import COLOR from '../../foundation/color.mjs';
import styles from './SolidTab.module.scss.mjs';

const cx = classNames.bind(styles);
const SolidTabItem = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    icon,
    tabName,
    active,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("li", {
    className: cx('item'),
    ref: ref
  }, /*#__PURE__*/React.createElement(AnchorButton, {
    className: cx('link', {
      'is-selected': active
    }),
    ...rest
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: cx('icon')
  }, icon), tabName && /*#__PURE__*/React.createElement("span", null, tabName), active && /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uD604\uC7AC \uC704\uCE58")));
});
SolidTabItem.displayName = 'SolidTabItem';
const SolidTab = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    typeLayout,
    type,
    tabWidth,
    tabMaxWidth = '335px',
    colorSet = COLOR.gray100.name,
    items,
    selectedKey,
    selectedIndex
  } = _ref2;
  const isSolidTabFixed = typeLayout === 'fixed';
  const isLargeWidth = isSolidTabFixed && items.length > 2;
  return /*#__PURE__*/React.createElement("ul", {
    className: cx('article', `colorset-${colorSet}`, type, typeLayout, {
      'width-large': isLargeWidth
    }),
    style: {
      width: tabWidth,
      maxWidth: isLargeWidth ? tabMaxWidth : undefined
    },
    ref: ref
  }, items.map((_ref3, index) => {
    let {
      ref: $item,
      ...item
    } = _ref3;
    const key = item.key ?? index;
    return /*#__PURE__*/React.createElement(SolidTabItem, {
      ...item,
      key: key,
      active: selectedIndex === index || selectedKey === key,
      ref: $item
    });
  }));
});
SolidTab.displayName = 'SolidTab';

export { SolidTab as default };
